/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef } from 'react';
import classNames from 'classnames';
import Image from 'next/image';
import useTranslation from 'next-translate/useTranslation';

import { Button, CheckboxWithText } from '@/ui/index';
import { useIsCabinet } from '@/hooks/useCabinet';
import useOnClickOutside from '@/hooks/useClickOutside';
import { CloseSquare } from '@/icons/index';

import styles from './TermsConditions.module.scss';

const Terms = ({
  active = false,
  setActive = () => null,
  formikHandler = () => null,
  className,
  classNameInner,
  innerText,
  isFetching = false,
  formik,
  data,
}) => {
  const { t, lang } = useTranslation();
  const isCabinet = useIsCabinet();
  const [accepted, setAccepted] = React.useState(formik?.values?.terms);
  const outsideRef = useRef(null);
  React.useEffect(() => {
    if (active) {
      document.documentElement.classList.add('overflow');
    } else {
      document.documentElement.classList.remove('overflow');
    }

    return () => {
      document.documentElement.classList.remove('overflow');
    };
  }, [active]);

  const printPdf = () => {
    document.getElementById('pdfDocument').contentWindow.print();
  };

  useOnClickOutside(outsideRef, () => handleClose());

  const clickHandler = () => {
    setActive(false);
    !isCabinet && formik.setFieldValue('terms', accepted);
    isCabinet && formikHandler();
    window.dataLayer = window.dataLayer || [];
    window?.dataLayer?.push({
      event: 'agreecontract',
    });
  };

  const handleCheck = () => {
    setAccepted((accepted) => !accepted);
  };

  const handleClose = () => {
    if (!isCabinet) {
      formik.setFieldValue(
        'terms',
        formik.values.terms === accepted ? formik.values.terms : false,
      );
      setAccepted(
        formik.values.terms === accepted ? formik.values.terms : false,
      );
      setActive(false);
    }
  };

  return (
    <div
      className={classNames([
        styles.wrap,
        { [styles.open]: active },
        className,
      ])}
      itemScope
      itemType='https://schema.org/Property'
    >
      <div
        ref={outsideRef}
        className={classNames([styles.termsInner, classNameInner])}
      >
        {!isCabinet && (
          <CloseSquare
            className={styles.closeModal}
            onClick={() => {
              setActive(false);
            }}
          />
        )}

        <div className={styles.termsContent}>
          <iframe
            src='/assets/esim/files/BKC-contract.pdf'
            id='pdfDocument'
            style={{ display: 'none' }}
            title={t('esim:common.termsAndConditions')}
          />
          <h2 className={styles.title}>
            {t('esim:common.termsAndConditions')}
          </h2>
          <div
            dangerouslySetInnerHTML={{
              __html: !innerText ? data?.content ?? data?.text : innerText,
            }}
          ></div>
          <br /> <br />
          {!innerText && (
            <table width='100%'>
              <tr>
                <td>
                  <strong>
                    {t('esim:contract.company')}
                    <br /> <br />
                    <br />
                  </strong>
                </td>
                <td>
                  <strong>
                    {t('esim:contract.customer')} <br /> <br />
                    <br />
                  </strong>
                </td>
              </tr>
              <tr>
                <td>
                  ( {t('esim:contract.mark')}) <br /> <br />
                  <br />
                </td>
                <td>
                  ({t('esim:contract.signature')}) <br /> <br />
                  <br />
                </td>
              </tr>
            </table>
          )}
        </div>
        <div className={styles.bottom_buttons}>
          <CheckboxWithText
            reverse
            checked={accepted}
            onChange={handleCheck}
            titleClassName={styles.checkbox_label_terms}
          >
            {t('esim:common.readAccept')}
          </CheckboxWithText>
          {!innerText && (
            <div className={styles.button_groups}>
              <a
                href='/assets/esim/files/BKC-contract.pdf'
                download
                className={styles.download_btn}
              >
                <Image
                  src='/assets/esim/download.svg'
                  width={16}
                  height={16}
                  layout='fixed'
                  alt='download icon'
                  title='Download Icon'
                  loading='lazy'
                />
              </a>
              <Button onClick={() => printPdf()} className={styles.print_btn}>
                <Image
                  src='/assets/esim/printer.svg'
                  width={16}
                  height={16}
                  layout='fixed'
                  alt='download icon'
                  title='Download Icon'
                  loading='lazy'
                />
              </Button>
            </div>
          )}
        </div>
        <div className={styles.acceptButtons}>
          <Button
            className={classNames([
              styles.terms_accept_btn,
              { [styles.terms_accept_btn_height]: isCabinet },
            ])}
            onClick={clickHandler}
            disabled={!accepted}
          >
            {t('cabinet:common.Accept')}
          </Button>
          <Button
            className={classNames([
              styles.terms_accept_btn,
              styles.terms_close_btn,
            ])}
            variant='outline'
            onClick={handleClose}
          >
            {t('esim:checkout.actions.close')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Terms;
